/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function( $ ) {
	
	/** Shared vars **/
	var $html = $( 'html' ),
		$body_header = $( '.body-header' ),
		$body_header_height = $body_header.height(),
		$header_bottom = $( '#header-bottom' ),
		$back_to_top = $( '.back-to-top' ),
		$swoop_orig_width = 3000,
		$swoop_orig_height = 82,
		$slick_carousels = $( '[class*="component-gallery"].gallery-slide .gallery-stage, [class*="component-gallery"].gallery-slide-strip .gallery-stage' ),
		submenu_event_action = 'hover',
		preview_video_icon = '/wp-content/themes/fremont/dist/images/icon-play-black.svg',
		_recalculate_swoops,
		_recalculate_hero_video,
		_in_array,
		_scroll_to,
		_hide_backtotop,
		_show_backtotop,
		_determine_submenu_event_action;

	// Adjust global Fancybox defaults
	$.fancybox.defaults.idleTime = 0;
	$.fancybox.defaults.btnTpl = {
		close: '' +
		'<button data-fancybox-close class="btn btn-primary btn-xs btn-has-inner">' +
		'	<span class="btn-inner">' +
		'		Return to Page' +
		'	</span>' +
		'</button>'
	};
	
	/** Function definitions **/
	
	/**
	 * Should work just like PHP's in_array()
	 *
	 * @param needle
	 * @param array_haystack
	 * @returns {boolean}
	 * @private
	 */
	_in_array = function( needle, array_haystack ) {
		var haystack_size = array_haystack.length;
		if( array_haystack > 0 ) {
			for( var index = 0; index < haystack_size; index++ ) {
				if( needle === array_haystack[ index ] ) {
					return true;
				}
			}
		}
		// If reached here, something went wrong
		return false;
	};
	
	/**
	 * Redefines submenu event action
	 *
	 * @private
	 */
	_determine_submenu_event_action = function() {
		// If on a device with touch enabled, switch event to look for click action
		if( 'ontouchstart' in document.documentElement ) {
			submenu_event_action = 'click';
		} else {
			submenu_event_action = 'hover';
		}
	};
	
	/**
	 * Scrolls screen to give position
	 *
	 * @param anim_speed
	 * @param complete
	 * @private
	 */
	_scroll_to = function( top_pos, anim_speed, complete ) {
		
		// Pause slick carousels so they don't interrupt with smooth scroll
		$slick_carousels.slick( 'slickPause' );
		
		// Validate animation speed
		if( undefined !== anim_speed && typeof(anim_speed) !== 'number' ) {
			anim_speed = 800;
		}
		
		$( 'html, body' ).animate( {
			scrollTop: top_pos
		}, anim_speed )
		
		// Ensure complete fires only once
			.promise()
			.then( complete );
		
		// Resume slick carousels
		$slick_carousels.slick( 'slickPlay' );
	};
	
	/**
	 * Hides back to top button
	 *
	 * @private
	 */
	_hide_backtotop = function() {
		if( $back_to_top.css( 'display' ) !== 'none' ) {
			$back_to_top.fadeOut( 'fast' );
		}
	};
	
	/**
	 * Shows back to top button
	 *
	 * @private
	 */
	_show_backtotop = function() {
		if( $back_to_top.css( 'display' ) === 'none' ) {
			$back_to_top.fadeIn( 'fast' );
		}
	};
	
	/**
	 * Recalculates hero videos to always fit its container. Hero mask always fills the container
	 * so use it for the base calculations.
	 *
	 * @private
	 */
	_recalculate_hero_video = function() {
		$( '.hero-video .video-player' ).each( function() {
			var hero_mask = $( this ).closest( '.page-hero' ).find( '.hero-mask' ),
				player_ratio_height = 9,
				player_ratio_width = 16,
				player_width = 0,
				player_height = 0;
			
			if( hero_mask.height() / hero_mask.width() >= player_ratio_height / player_ratio_width ) {
				player_height = hero_mask.height();
				player_width = Math.ceil( hero_mask.height() * player_ratio_width / player_ratio_height );
				
				// Realign video player
				$( this ).css( {
					top: 0,
					left: '50%',
					transform: 'translateX(-50%)'
				} );
			} else {
				player_width = hero_mask.width();
				player_height = Math.ceil( hero_mask.width() * player_ratio_height / player_ratio_width );
				
				// Realign video player
				$( this ).css( {
					top: 0,
					left: 0,
					transform: 'none'
				} );
			}
			
			// Set video player dimensions
			$( this ).css( {
				width: player_width,
				height: player_height
			} );
		} );
	};
	
	/**
	 * Recalculate swoops between section layout modules
	 *
	 * @private
	 */
	_recalculate_swoops = function() {
		var $swoop_height = $( window ).width() * $swoop_orig_height / $swoop_orig_width;
		
		$( '.swoop-top-svg' ).attr( {
			width: $( window ).width(),
			height: $swoop_height
		} ).closest( '.section-top-bg' ).css( {
			height: $swoop_height,
			top: -$swoop_height + 1
		} ).closest( '.layout-section' ).css( {
			paddingBottom: $swoop_height
		} );
	};

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				
				/** Section top background fade for even (sections with darker background) **/
				$( '.layout-section.even.has-background-image .section-top-bg-fade' ).each( function() {
					var num_of_fades = Math.floor( $( this ).height() ),
						fade_part = (100 / num_of_fades).toFixed( 4 );
					
					// Force styles
					$( this ).css( {
						overflow: 'hidden'
					} );
					
					// Append divs to create a faded-bottom look on a div that already has a gradient background
					for( var sec = 0; sec < num_of_fades; sec++ ) {
						$( '<div>', {
							class: 'section-top-bg-fade-gradient'
						} )
							.css( {
								height: 1,
								opacity: (100 - sec * fade_part) / 100
							} )
							.appendTo( $( this ) );
					}
				} );
				
				/** Back to Top button **/
				$( document ).on( 'scroll', function() {
					if( $( this ).scrollTop() > $( 'header.banner' ).outerHeight() ) {
						_show_backtotop();
					} else {
						_hide_backtotop();
					}
				} );
				$back_to_top.find( '.btn' ).on( 'click', function( event ) {
					// Prevent default anchor click behavior
					event.preventDefault();
					
					// Using jQuery's animate() method to add smooth page scroll
					_scroll_to( 0 );
				} );
				
				/** Hero jump links **/
				$( '.hero-to-next .btn' ).on( 'click', function( event ) {
					// Prevent default anchor click behavior
					event.preventDefault();
					
					// Using jQuery's animate() method to add smooth page scroll
					_scroll_to( $( '.page-hero' ).next().offset().top );
				} );
				
				/** Smooth scroll for anchor tags within pages **/
				$( 'a[href^="#"]' ).on( 'click', function( event ) {
					// Make sure this.hash has a value before overriding default behavior
					if( this.hash.length > 0 ) {
						// Prevent default anchor click behavior
						event.preventDefault();
						
						// Store hash
						var hash = this.hash;
						
						// Calculate top position to scroll to
						var hash_top_pos = $( hash ).offset().top;
						
						// Take top margin and padding into consideration
						hash_top_pos -= parseInt( $( hash ).css( 'padding-top' ) );
						hash_top_pos -= parseInt( $( hash ).css( 'margin-top' ) );
						
						// Using jQuery's animate() method to add smooth page scroll
						_scroll_to( hash_top_pos, function() {
							// Add hash (#) to URL when done scrolling (default click behavior)
							window.location.hash = hash;
						} );
					}
				} );
				
				/** Custom select drop-down **/
				$( document ).on( 'click', function( e ) {
					// Process only on left mouse click
					if( e.which === 1 ) {
						var target = $( e.target ),
							select = $( '.select' ),
							selected = $( '.selected' );
						
						// Toggle the active class from select
						if( target.parents().is( select ) ) {
							if( select.hasClass( 'active' ) ) {
								select.removeClass( 'active' );
							} else {
								select.addClass( 'active' );
							}
							
							// Toggle the active class from <li> of dropdown list
							if( target.is( '.select-option' ) ) {
								target.parent()
									.addClass( 'active' )
									.siblings().removeClass( 'active' );
							}
						} else {
							select.removeClass( 'active' );
						}
						
						// Updating the selected option
						if( target.closest( 'ul' ).is( '.select-list' ) ) {
							selected.text( target.text() );
						}
					}
				} );
				
				/** VR View background with images and videos **/
				$( '.vrview' ).each( function() {
					var vr_view = false,
						options = {
							height: '100%',
							hide_fullscreen_button: true,
							is_autopan_off: true,
							is_debug: false,
							is_stereo: false,
							is_vr_off: true,
							loop: true,
							muted: true,
							volume: 0,
							width: '100%'
						};
					
					vr_view = new VRView.Player( '#' + $( this ).attr( 'id' ), options );
					$( this ).removeAttr( 'data-source' );
				} );
				
				/** YouTube and Vimeo backgrounds **/
				$( '.hero-video.youtube, .hero-video.vimeo' ).each( function() {
					$( '<iframe />', {
						class: 'video-player',
						src: $( this ).attr( 'data-video' ),
						frameborder: 0,
						webkitallowfullscreen: 1,
						mozallowfullscreen: 1,
						allowfullscreen: 1,
						style: 'width:100%; height:100vh;'
					} ).appendTo( $( this ) );
					$( this ).removeAttr( 'data-video' );
					
					// Mute Vimeo videos in hero with Vimeo JS library
					if( $( this ).hasClass( 'vimeo' ) ) {
						var vimeo = new Vimeo.Player( $( this ) );
						vimeo.setVolume( 0 );
					}
				} );
				
				/** Fancybox for all wp-image with links **/
				$( 'a.img-fancybox' ).each( function() {
					
					var image_pattern = /\S*(youtu|youtube|vimeo)\S*/i,
						is_video = false,
						href = $( this ).attr( 'href' );
					
					// Check if href source is a video
					if( href && href.length > 0 && href.match( image_pattern ) ) {
						is_video = true;
					}
					
					// Construct round CTA button
					$( this ).css( {
						position: 'relative',
						display: 'block'
					} );
					
					// Inject round CTA button. preview_video_icon comes from PHP.
					if( is_video ) {
						$( '<button />', {
							class: 'btn btn-has-inner btn-primary btn-round btn-preview btn-lg img-fancybox-preview'
						} )
							.css( {
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)'
							} )
							.html( '<span class="btn-inner"><img class="img-icon" src="' + preview_video_icon + '" /></span>' )
							.appendTo( $( this ) );
					}
					
				} ).fancybox();
				
				/** Slick carousels **/
				$slick_carousels.each( function() {
					var gallery_arrows = $( this ).siblings( '.gallery-arrows' ),
						prev_arrow = gallery_arrows.find( '.gallery-arrow.prev > .btn' ),
						next_arrow = gallery_arrows.find( '.gallery-arrow.next > .btn' );
					
					$( this ).slick( {
						mobileFirst: true,
						lazyLoad: 'progressive',
						prevArrow: prev_arrow,
						nextArrow: next_arrow,
						adaptiveHeight: true
					} );
				} );
				
				/** Display more gallery items **/
				$( '.gallery-load .btn-load-more' ).on( 'click', function( e ) {
					var module = $( this ).closest( '.gallery-load' ),
						active_set = module.find( '[data-loadset]:hidden' ).data( 'loadset' );
					
					// Display next set
					if( active_set ) {
						var active_modules = module.find( '[data-loadset="' + active_set + '"]' );
						
						// Make active set visible
						active_modules.fadeIn();
						
						// Update matchheight
						$.fn.matchHeight._update();
					}
					
					// Check if there are more items to show so button can be disabled
					if( module.find( '[data-loadset]:hidden' ).length <= 0 ) {
						$( this ).attr( 'disabled', true );
					}
				} );
				
				/** Toggle short menu on mobile when the full menu is visibile **/
				var short_mobile_menu = $( '#header-mid' );
				$header_bottom
					.on( 'show.bs.collapse', function() {
						short_mobile_menu.slideUp( 'fast' );
					} )
					.on( 'hide.bs.collapse', function() {
						short_mobile_menu.slideDown( 'fast' );
					} );
				
				/** Toggle submenus **/
				_determine_submenu_event_action();
				$( 'header.banner .menu-item-has-children > a' ).on( submenu_event_action, function( event ) {
					var $menu_item = $( this ).closest( '.menu-item' ),
						$submenu = $menu_item.children( '.sub-menu' );
					
					// Prevent default behavior
					event.preventDefault();
					
					// Show/hide submenu and add class
					if( $menu_item.hasClass( 'active' ) ) {
						$menu_item.removeClass( 'active' );
						
						// If on mobile, use slide animation for consistency with other mini mobile nav animation
						if( submenu_event_action === 'click' ) {
							$submenu.slideUp( 'fast' );
						}
					} else {
						$menu_item.addClass( 'active' );
						
						// If on mobile, use slide animation for consistency with other mini mobile nav animation
						if( submenu_event_action === 'click' ) {
							$submenu.slideDown( 'fast' );
						}
					}
					
					return false;
				} );
				
				// Attach class to alternating 2-column layout so CSS can target it
				$( '.section-modules' ).each( function() {
					// Keep track of which layout
					var layout_classname = 'layout-alternating-2-column',
						layout_count = 1;
					
					$( this ).find( '.layout' ).each( function() {
						if( $( this ).hasClass( layout_classname ) ) {
							var next_layout = $( this ).next();
							
							/**
							 * A few ways to tell if next layout should get `even` class:
							 *
							 *   1. If next layout is the same type
							 *   2. If current layout is odd
							 */
							if( next_layout.hasClass( layout_classname ) &&
								layout_count % 2 !== 0
							) {
								next_layout.addClass( 'even' );
							}
							
							layout_count++;
						}
					} );
					
				} );

			},
			finalize: function() {
			}
		}
	};
	
	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function( func, funcname, args ) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[ func ];
			fire = fire && typeof namespace[ func ][ funcname ] === 'function';
			
			if( fire ) {
				namespace[ func ][ funcname ]( args );
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire( 'common' );
			
			// Fire page-specific init JS, and then finalize JS
			$.each( document.body.className.replace( /-/g, '_' ).split( /\s+/ ), function( i, classnm ) {
				UTIL.fire( classnm );
				UTIL.fire( classnm, 'finalize' );
			} );
			
			// Fire common finalize JS
			UTIL.fire( 'common', 'finalize' );
		}
	};
	
	// Load Events
	$( document ).ready( UTIL.loadEvents );
	
	document.onreadystatechange = function() {
		if( document.readyState === 'complete' ) {
			
			// Swoops
			_recalculate_swoops();
			
			// Recalculate video player sizes
			_recalculate_hero_video();
			
			// Update matchheight in case it fired too soon
			$.fn.matchHeight._update();
			
			// Cards in galleries to have the same height
			$( '[class*="component-gallery"] [class*="component-card"]:not(.image-transparent)' ).matchHeight();
			$( '[class*="component-gallery"] [class*="component-card"].image-transparent .card-content' ).matchHeight();
			
			window.setTimeout( function() {
				$( '.transition-mask' ).fadeOut( 500 );
			}, 100 );
		}
	};
	
	// On window resize...
	window.onresize = function() {
		// Recalculate swoops
		_recalculate_swoops();
		// Recalculate video player sizes
		_recalculate_hero_video();
		// Redefine submenu event action
		_determine_submenu_event_action();
		// Update match height
		$.fn.matchHeight._update();
	};
	
})( jQuery ); // Fully reference jQuery after this point.
